export default {
  parent_user: null,
  loading: false,
  lab_tests: [],
  lab_test: null,
  FilteredCount: 0,
  total: 0
}